import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../../../locale";
import InviteCouponSectionHeading from "./InviteCouponSectionHeading";

const InviteCouponStep2 = ({
  debitedFormatted,
  couponCode,
  dateTimeLabel,
  shareHint,
  onFinish,
}) => (
  <div className="flex flex-column gap-4 align-items-center text-center">
    <div
      className="flex align-items-center justify-content-center border-circle"
      style={{
        width: "5.3rem",
        height: "5.3rem",
        background: "var(--theme-primary, #1DAF61)",
      }}
    >
      <i
        className="pi pi-check text-2xl p-3"
        style={{
          backgroundColor: "var(--theme-background, #FFFFFF)",
          color: "var(--theme-text, #171717)",
          borderRadius: "50%",
        }}
      />
    </div>
    <div>
      <h3 className="text-xl font-bold m-0" style={{ color: "var(--theme-text, #172B4D)" }}>
        {localeText("inviteCouponSuccessTitle")}
      </h3>
      <p className="text-sm m-0 mt-2" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
        {localeText("inviteCouponSuccessMeta", { dateTime: dateTimeLabel })}
      </p>
    </div>

    <div
      className="w-full border-1 border-round-md overflow-hidden text-left"
      style={{ borderColor: "var(--theme-border, #EBEBEB)" }}
    >
      <div className="p-4 bg-white w-full text-center">
        <div
          className="text-xs font-medium mb-1"
          style={{ color: "var(--theme-text-muted, #7A869A)" }}
        >
          {localeText("inviteCouponYouUsed")}
        </div>
        <div className="text-2xl font-bold" style={{ color: "var(--theme-text, #171717)" }}>
          - {debitedFormatted} ECR
        </div>
      </div>
      <InviteCouponSectionHeading label={localeText("inviteCouponCodeSection")} />
      <div className="p-4 bg-white">
        <div
          className="font-bold text-lg px-3 py-2 border-1 border-round-md text-center"
          style={{
            borderColor: "var(--theme-border, #E0E0E0)",
            color: "var(--theme-text, #344563)",
          }}
        >
          {couponCode}
        </div>
      </div>
    </div>

    <p
      className="text-sm m-0 text-left w-full"
      style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
    >
      {shareHint}
    </p>

    <Button
      type="button"
      label={localeText("inviteCouponFinish")}
      className="w-full border-round-md p-no-outline"
      style={{ backgroundColor: "var(--theme-primary, #272360)" }}
      color="var(--theme-primary-text, #ffffff)"
      onClick={onFinish}
    />
  </div>
);

export default InviteCouponStep2;
